export const en = {
  "header": {
    "brand": "CikaStudio",
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "nav": {
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "actions": {
    "copy": "Copy",
    "download": "Download",
    "clear": "Clear",
    "copied": "Copied!",
    "copyAll": "Copy All",
    "downloadTxt": "Download TXT",
    "generate": "Generate",
    "regenerate": "Regenerate",
    "format": "Format",
    "minify": "Minify",
    "validate": "Validate",
    "convert": "Convert"
  },
  "footer": {
    "privacy": "Privacy",
    "terms": "Terms",
    "email": "Contact",
    "moreTools": "More Tools",
    "copyright": "© {year} CikaStudio. All rights reserved."
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "Light",
    "dark": "Dark"
  },
  "common": {
    "clientSide": "100% client-side",
    "noUpload": "No data upload",
    "noAccount": "No account required",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success"
  },
  "pdfMerge": {
    "title": "PDF Merger",
    "subtitle": "Merge multiple PDF files into one. ",
    "privacy": "100% client-side",
    "noUpload": "no upload needed",
    "uploadTitle": "Add PDF Files",
    "uploadDesc": "Drag & drop or click to select. Reorder by dragging.",
    "addFiles": "Add PDFs",
    "files": "Files",
    "pages": "pages",
    "dragReorder": "Drag to reorder",
    "selectPdf": "Please select PDF files",
    "invalidPdf": "Invalid or corrupted PDF file",
    "minFiles": "Please add at least 2 PDF files to merge",
    "minValid": "Please add at least 2 valid PDF files",
    "merging": "Merging...",
    "merged": "Merged successfully",
    "merge": "Merge PDFs"
  },
  "content": {
    "privacy": {
      "title": "Privacy & Security",
      "description": "🔒 All PDF merging happens locally in your browser. Your documents are never uploaded to any server."
    },
    "guide": {
      "title": "How to Use PDF Merger",
      "description": "Merge multiple PDF files into one document instantly in your browser.",
      "steps": [
        {
          "title": "Upload PDF files",
          "description": "Drag and drop or click to select multiple PDF files. The tool supports any number of files within your device memory limits."
        },
        {
          "title": "Arrange order",
          "description": "Drag files to reorder them. The merged PDF will follow the sequence shown in the file list from top to bottom."
        },
        {
          "title": "Download merged PDF",
          "description": "Click the merge button to combine all files into a single PDF. Download the result instantly. Original files are never modified."
        }
      ]
    },
    "features": {
      "title": "Key Features",
      "items": [
        "Merge unlimited PDF files in one operation",
        "Drag-and-drop file ordering",
        "Preserves original page content and quality",
        "Fast client-side processing with no upload wait",
        "Download merged document instantly",
        "100% client-side processing — zero data upload"
      ]
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "items": [
        {
          "question": "Are my PDFs sent to a server?",
          "answer": "No. All merging happens locally in your browser using the PDF-Lib library. Your documents never leave your device, making it safe for confidential contracts, reports, and legal documents."
        },
        {
          "question": "Is there a file size or page limit?",
          "answer": "There is no strict limit, but very large PDFs may be constrained by your browser memory. Most devices handle files up to 50MB and hundreds of pages comfortably."
        },
        {
          "question": "Will bookmarks and metadata be preserved?",
          "answer": "The merger preserves all page content, images, and text. Some advanced PDF features like interactive forms and JavaScript may be simplified during the merge process."
        }
      ]
    },
    "related": {
      "title": "Related Tools",
      "tools": [
        {
          "name": "Image Converter",
          "url": "/image/image-converter",
          "description": "Convert between JPG, PNG, and WebP instantly in your browser."
        },
        {
          "name": "Image Watermarker",
          "url": "/image/image-watermarker",
          "description": "Add text or logo watermarks to your images with batch processing."
        },
        {
          "name": "Base64 Converter",
          "url": "/converter/base64",
          "description": "Encode and decode Base64 strings quickly and securely."
        }
      ]
    }
  }
};
